import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { useMemo } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function N() {
    const { useLang, useRouter, Link, useState, useEffect } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const TABS_MAP: any = {
        de: [t('secN_tab2'), t('secN_tab1'), t('secN_tab3')],
        fr: [t('secN_tab1'), t('secN_tab2'), t('secN_tab3')],
        uk: [t('secN_tab1'), t('secN_tab2')],
        it: [t('secN_tab1'), t('secN_tab2')],
        es: [t('secN_tab1'), t('secN_tab2')],
    };
    const tabs: any = TABS_MAP[locale];
    const [gap, setGap] = useState(24);
    const POSTER_MAP: any = {
        uk: '_uk',
        de: '',
        es: '_es',
        it: '_it',
    };
    const listsMap: any = {
        de: {
            1: [
                {
                    img: '/responsive/picture/power-independence/14_1_1',
                    desc: t('secN_tab1_card1_text'),
                    link: t('secN_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_2',
                    desc: t('secN_tab1_card2_text'),
                    link: t('secN_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_3',
                    desc: t('secN_tab1_card3_text'),
                    link: t('secN_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_4',
                    desc: t('secN_tab1_card4_text'),
                    link: t('secN_tab1_card4_link'),
                },
            ],
            0: [
                {
                    img: '/responsive/picture/power-independence/14_2_1',
                    desc: t('secN_tab2_card1_text'),
                    link: t('secN_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_2',
                    desc: t('secN_tab2_card2_text'),
                    link: t('secN_tab2_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_3',
                    desc: t('secN_tab2_card3_text'),
                    link: t('secN_tab2_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_4',
                    desc: t('secN_tab2_card4_text'),
                    link: t('secN_tab2_card4_link'),
                },
            ],
            2: [
                {
                    img: '/responsive/picture/power-independence/14_3_1',
                    desc: t('secN_tab3_card1_text'),
                    link: t('secN_tab3_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_3_2',
                    desc: t('secN_tab3_card2_text'),
                    link: t('secN_tab3_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_3_3',
                    desc: t('secN_tab3_card3_text'),
                    link: t('secN_tab3_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_3_4',
                    desc: t('secN_tab3_card4_text'),
                    link: t('secN_tab3_card4_link'),
                },
            ],
        },
        fr: [
            {
                img: '/responsive/picture/power-independence/14_1',
                desc: t('secN_card1_text'),
                link: t('secN_card1_link'),
            },
            {
                img: '/responsive/picture/power-independence/14_2',
                desc: t('secN_card2_text'),
                link: t('secN_card2_link'),
            },
            {
                img: '/responsive/picture/power-independence/14_3',
                desc: t('secN_card3_text'),
                link: t('secN_card3_link'),
            },
            {
                img: '/responsive/picture/power-independence/14_4',
                desc: t('secN_card4_text'),
                link: t('secN_card4_link'),
            },
            {
                img: '/responsive/picture/power-independence/14_5',
                desc: t('secN_card5_text'),
                link: t('secN_card5_link'),
            },
        ],
        uk: {
            0: [
                {
                    img: '/responsive/picture/power-independence/14_1_1',
                    desc: t('secN_tab1_card1_text'),
                    link: t('secN_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_2',
                    desc: t('secN_tab1_card2_text'),
                    link: t('secN_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_3',
                    desc: t('secN_tab1_card3_text'),
                    link: t('secN_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_4',
                    desc: t('secN_tab1_card4_text'),
                    link: t('secN_tab1_card4_link'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/power-independence/14_2_1',
                    desc: t('secN_tab2_card1_text'),
                    link: t('secN_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_2',
                    desc: t('secN_tab2_card2_text'),
                    link: t('secN_tab2_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_3',
                    desc: t('secN_tab2_card3_text'),
                    link: t('secN_tab2_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_4',
                    desc: t('secN_tab2_card4_text'),
                    link: t('secN_tab2_card4_link'),
                },
            ],
        },
        it: {
            0: [
                {
                    img: '/responsive/picture/power-independence/14_1_1',
                    desc: t('secN_tab1_card1_text'),
                    link: t('secN_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_2',
                    desc: t('secN_tab1_card2_text'),
                    link: t('secN_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_3',
                    desc: t('secN_tab1_card3_text'),
                    link: t('secN_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_4',
                    desc: t('secN_tab1_card4_text'),
                    link: t('secN_tab1_card4_link'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/power-independence/14_2_1',
                    desc: t('secN_tab2_card1_text'),
                    link: t('secN_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_2',
                    desc: t('secN_tab2_card2_text'),
                    link: t('secN_tab2_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_3',
                    desc: t('secN_tab2_card3_text'),
                    link: t('secN_tab2_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_4',
                    desc: t('secN_tab2_card4_text'),
                    link: t('secN_tab2_card4_link'),
                },
            ],
        },
        es: {
            0: [
                {
                    img: '/responsive/picture/power-independence/14_1_1',
                    desc: t('secN_tab1_card1_text'),
                    link: t('secN_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_2',
                    desc: t('secN_tab1_card2_text'),
                    link: t('secN_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_3',
                    desc: t('secN_tab1_card3_text'),
                    link: t('secN_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_1_4',
                    desc: t('secN_tab1_card4_text'),
                    link: t('secN_tab1_card4_link'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/power-independence/14_2_1',
                    desc: t('secN_tab2_card1_text'),
                    link: t('secN_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_2',
                    desc: t('secN_tab2_card2_text'),
                    link: t('secN_tab2_card2_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_3',
                    desc: t('secN_tab2_card3_text'),
                    link: t('secN_tab2_card3_link'),
                },
                {
                    img: '/responsive/picture/power-independence/14_2_4',
                    desc: t('secN_tab2_card4_text'),
                    link: t('secN_tab2_card4_link'),
                },
            ],
        },
    };
    const [items, setItems] = useState(Array.isArray(listsMap[locale]) ? listsMap[locale] : listsMap[locale]?.[0]);

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeFunc = () => {
                if (!Array.isArray(listsMap[locale])) {
                    const target = document.querySelector('.power-independence-N .tabs-inner') as HTMLUListElement;
                    target.style.transition = 'left .4s ease';
                    if (target.offsetWidth > window.innerWidth && active > 1) {
                        target.style.left = `${window.innerWidth - target.offsetWidth}px`;
                    } else {
                        target.style.left = `${0}px`;
                    }
                }
            };
            resizeFunc();
            window.addEventListener('resize', resizeFunc);
            return () => window.removeEventListener('resize', resizeFunc);
        }
    }, [active]);

    useEffect(() => {
        setItems(Array.isArray(listsMap[locale]) ? listsMap[locale] : listsMap[locale]?.[active]);
    }, [active]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    const renderSwiper = useMemo(() => {
        return (
            <Swiper
                className={`swiper-box swiper-box-${active}`}
                effect="fade"
                modules={[Scrollbar, Navigation]}
                navigation={true}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {items?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <EFPicture
                            className="card-img"
                            src={`${card?.img}${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                            srcPad={`${card?.img}_375${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                            srcMobile={`${card?.img}_375${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                            alt={card.desc}
                        />
                        <p className="card-desc">{card?.desc}</p>
                        <Link className="card-link" href={card?.link}>
                            <span className="link-text">{t('common_card_more')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                <path
                                    d="M6.50006 12.3291L10.5001 8.3291L6.50006 4.3291"
                                    stroke="#2673FF"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        );
    }, [active, items, gap]);

    return (
        <div id="power-independence-N" className={`power-independence-N ${css['power-independence-N']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secN_title')}</p>
                    {!Array.isArray(listsMap[locale]) && (
                        <div className="tabs">
                            <ul className="tabs-inner" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                                {tabs?.map((tab: string, k: number) => (
                                    <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                                        {tab}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
                {renderSwiper}
            </div>
        </div>
    );
}
